import React from 'react';
import PropTypes from 'prop-types';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import GoalStrategiesDetailsMetaOverride
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep/Content/GoalStrategiesDetailsMetaOverride';
import {
  GoalStrategiesDetailsLayout,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep/Content/GoalStrategiesDetailsLayout';
import {
  GoalStrategyDetailsSkeleton,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep/Content/Sections/GoalStrategyDetailsSkeleton';
import DataContainer from 'Components/UI/DataContainer';
import fr from 'facet-rest';
import { noop } from 'Helpers/PropTypes';

const GoalStrategyDetailsContainer = ({
  currentGoalDetailResource, onBack,
}) => {
  return (
    <DataContainer
      component={MetaResourceRenderer}
      componentProps={{
        LayoutProps: {
          showGoalStepper: false,
          showBackButton: true,
          onBack: () => onBack(),
          backLabel: 'Back to all goals',
        },
        metaOverrideSet: GoalStrategiesDetailsMetaOverride,
        layout: GoalStrategiesDetailsLayout,
        resource: currentGoalDetailResource,
      }}
      skeleton={GoalStrategyDetailsSkeleton}
    />
  );
};

GoalStrategyDetailsContainer.defaultProps = {
  onBack: noop,
};

GoalStrategyDetailsContainer.propTypes = {
  currentGoalDetailResource: PropTypes.instanceOf(fr.Resource).isRequired,
  onBack: PropTypes.func,
};

export default GoalStrategyDetailsContainer;
